import axios from 'axios'
import {router, cookie, vue} from '../main'

const axiosInstance = axios.create({
  baseURL: '/api/',
  timeout: 20000
})

const checkEr = function (err) {
  if (!err.response.status) {
    cookie.delete('session_id')
    router.push('/login')
    return Promise.reject(err)
  }
  if (err.response.status === 400) {
    return err.response
  }
  if (err.response.status === 401) {
    cookie.delete('session_id')
    router.push('/login')
  }
  if (err.response.status === 403) {
    vue.$bvToast.toast(vue.$t('api permission error'), {
      title: vue.$t('Error'),
      variant: 'danger',
      solid: true
    })
  }
  if (err.response.status === 502) {
    cookie.delete('session_id')
    if (router.currentRoute.name !== 'Login') {
      router.push('/login')
    }
    vue.$bvToast.toast(vue.$t('Core not avalible'), {
      title: vue.$t('Error'),
      variant: 'danger',
      solid: true
    })
  }
  return Promise.reject(err)
}

axiosInstance.interceptors.response.use(null, checkEr)
axiosInstance.defaults.withCredentials = true

export default axiosInstance



// WEBPACK FOOTER //
// ./src/utils/api.js